import { BiPlus } from "react-icons/bi";

const DefaultNode = ({ data, setOpenOverDropdown }) => {
    const handleAdd = (e) => {
        e.stopPropagation();
        data.onAddNext?.(data.id);
    };

     return (
        <div
            className="default_node start_node"
            onClick={handleAdd}
        >
            <div className="custom-node-content">
                <div className="custom-node-title">
                    <BiPlus /> Start
                </div>
            </div>
        </div>
    );
};

export default DefaultNode;